
  import { mapState } from 'vuex';

  import search from "@/mixins/search";

  export default {
    name: "ModalPriceRange",
    mixins: [
      search
    ],
    props: {
      show: {
        type: Boolean,
        default: false
      },
    },
    data() {
      return {
        isOpen: false,
        priceRange: [
          10,
          999
        ],
        limits: {
          min: 10,
          max: 999,
        }
      }
    },
    methods: {
      init() {
        this.priceRange = [
           this.filters.min_price,
           this.filters.max_price,
         ];
      },
      close() {
        this.$emit('close');
      },
      clear() {
        this.priceRange = [
          10,
          999
        ];
        this.action();
      },
      action() {
        this.filters.min_price = this.priceRange[0];
        this.filters.max_price = this.priceRange[1];

        this.submitSearch({
          data: true,
          redirect: 'properties'
        });
        this.close();
      }
    },
    computed: {
      isChanged() {
        return this.priceRange[0] !== this.limits.min || this.priceRange[1] !== this.limits.max;
      },
      ...mapState({
        avgPrice: state => state.properties.getAvgPriceRequest.data,
      }),
    },
    watch: {
      show(newVal) {
        this.initFilters();
        newVal && this.init();
        this.isOpen = newVal;
      }
    }
  }
